/** Discipline scope options per building entity (Multiple Buildings category). */
import { DISCIPLINE_HATS } from './disciplineHats';

export const ENTITY_DISCIPLINE_OPTIONS = DISCIPLINE_HATS.map((h) => ({
  value: h.id,
  label: h.label,
}));

export function formatEntityDisciplinesLabel(ids) {
  if (!ids?.length) return 'All disciplines';
  const names = ids
    .map((id) => ENTITY_DISCIPLINE_OPTIONS.find((o) => o.value === id)?.label || id)
    .filter(Boolean);
  return names.length ? names.join(', ') : 'All disciplines';
}
